import { useAct } from 'FlowBuilder/store'
import { useState } from 'react'
import './RedirectActionForm.scoped.scss'

function isValidUrl(string) {
  try {
    new URL(string)
    return true
  } catch {
    return false
  }
}

export default function RedirectActionForm({ actionId }) {
  const act = useAct()

  const action = useSel(s => s.actions.entities[s.local.selectedActionId])
  const config = action.config || {}
  const [touched, setTouched] = useState(false)

  const brandHomepageUrl = window.ENV?.CLIENT_BRAND?.custom_homepage_url
  const [mode, setMode] = useState(config.redirectUrl ? 'custom' : 'homepage')

  function update(data) {
    act.actions.upsert(actionId, { config: { ...config, ...data } })
  }

  function selectHomepage() {
    setMode('homepage')
    if (config.redirectUrl) update({ redirectUrl: '' })
  }

  function selectCustom() {
    setMode('custom')
  }

  const showUrlError = mode === 'custom' && touched && config.redirectUrl && !isValidUrl(config.redirectUrl)
  const showMissingHomepageError = mode === 'homepage' && !brandHomepageUrl

  return <div className="box narrow">
    <h2 className='no-margin-top'>Redirect</h2>

    <div
      className={`redirect-option ${mode === 'homepage' ? 'selected' : ''}`}
      onClick={selectHomepage}
    >
      <input
        type='radio'
        name={`redirect-mode-${actionId}`}
        checked={mode === 'homepage'}
        onChange={selectHomepage}
      />
      <div className='redirect-option-content'>
        <div className='redirect-option-title'>Redirect to homepage</div>
        {brandHomepageUrl
          ? <div className='redirect-option-meta'>{brandHomepageUrl}</div>
          : <div className='redirect-option-meta'>No brand homepage URL is configured.</div>
        }
        {showMissingHomepageError && (
          <p className='error-text'>
            Please set a homepage URL in your brand settings before using this option.
          </p>
        )}
      </div>
    </div>

    <div
      className={`redirect-option ${mode === 'custom' ? 'selected' : ''}`}
      onClick={selectCustom}
    >
      <input
        type='radio'
        name={`redirect-mode-${actionId}`}
        checked={mode === 'custom'}
        onChange={selectCustom}
      />
      <div className='redirect-option-content'>
        <div className='redirect-option-title'>Redirect to custom URL</div>
        {mode === 'custom' && (
          <div className='redirect-option-custom' onClick={e => e.stopPropagation()}>
            <input
              type='text'
              value={config.redirectUrl || ''}
              placeholder='https://'
              onChange={e => update({ redirectUrl: e.target.value })}
              onBlur={() => setTouched(true)}
            />
            {showUrlError && (
              <p className='error-text'>Please enter a valid URL starting with http:// or https://</p>
            )}
          </div>
        )}
      </div>
    </div>
  </div>
}
